import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";

/**
 * Firebase configuration - initialize with your Firebase project credentials.
 * Get these values from your Firebase Console:
 * https://console.firebase.google.com/project/YOUR_PROJECT/settings/general
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "",
};

// Check if Firebase is properly configured
const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey && 
  firebaseConfig.authDomain && 
  firebaseConfig.projectId &&
  firebaseConfig.appId
);

// Mock Firebase objects when not configured
const mockAuth = {
  currentUser: null,
  signOut: () => Promise.resolve(),
};

const mockGoogleProvider = {
  addScope: () => {},
};

let app: any = null;
let auth: any = mockAuth;
let googleProvider: any = mockGoogleProvider;

if (isFirebaseConfigured) {
  try {
    // Initialize Firebase
    app = initializeApp(firebaseConfig);

    // Initialize Firebase Authentication
    auth = getAuth(app);

    // Set persistence to LOCAL so user stays logged in across sessions
    setPersistence(auth, browserLocalPersistence).catch((error) => {
      console.error("Failed to set auth persistence:", error);
    });

    // Initialize Google Auth Provider
    googleProvider = new GoogleAuthProvider();

    // Optional: Add custom scopes if needed
    // googleProvider.addScope('profile');
    // googleProvider.addScope('email');
  } catch (error) {
    console.error("Failed to initialize Firebase:", error);
    // Fall back to mock objects
    auth = mockAuth;
    googleProvider = mockGoogleProvider;
  }
} else {
  console.warn(
    "Firebase configuration is incomplete. Google Sign-In will not work until you add Firebase credentials to your .env file.\n" +
    "Required environment variables:\n" +
    "- VITE_FIREBASE_API_KEY\n" +
    "- VITE_FIREBASE_AUTH_DOMAIN\n" +
    "- VITE_FIREBASE_PROJECT_ID\n" +
    "- VITE_FIREBASE_APP_ID\n" +
    "Get these from: https://console.firebase.google.com/project/YOUR_PROJECT/settings/general"
  );
}

export { auth, googleProvider, isFirebaseConfigured };
export default app;
